import { Logic, Operator } from 'core-components/types'

export const getInitialFilterForGPDetails = (globalPartnerId: string) => {
  return {
    logic: Logic.AND,
    filters: [
      {
        field: 'GlobalPartnerId',
        operator: Operator.EQUAL,
        value: globalPartnerId,
      },
      {
        field: 'Pbms',
        operator: Operator.EQUAL,
        value: '',
      },
      {
        field: 'Geo',
        operator: Operator.EQUAL,
        value: '',
      },
      {
        field: 'Products',
        operator: Operator.EQUAL,
        value: '',
      },
      {
        field: 'PartnerIds',
        operator: Operator.EQUAL,
        value: '',
      },
      {
        field: 'Managers',
        operator: Operator.EQUAL,
        value: '',
      },
    ],
  }
}
